import { ClickableDiv } from "@src/straps/utils/ClickableDiv";
import Button from "../../buttons/Button/Button";

export enum AlertEnum {
  Success = "success",
  Error = "error",
}

interface AlertsProps extends React.HTMLAttributes<HTMLDivElement> {
  readonly message: React.ReactNode;
  readonly status: AlertEnum;
  readonly onClose?: () => void;
}

const Alerts = ({ message, status, onClose, ...props }: AlertsProps) => {
  return (
    <ClickableDiv
      {...props}
      onClick={(e) => {
        e.stopPropagation();
      }}
      className="group/alert relative z-10 inline-flex max-w-[260px] cursor-default items-center rounded-sm bg-white p-3 shadow-md"
    >
      {message && <span className="ml-2 text-xs">{message}</span>}
      {!!onClose && (
        <div className="absolute right-0 top-0 bg-white/75 p-1 opacity-0 transition-opacity group-hover/alert:opacity-100 ">
          <Button
            noFrameVariant="combo-s"
            icon="close"
            dataTestId="alerts-close-button"
            onClick={onClose}
            color="secondary"
          />
        </div>
      )}
    </ClickableDiv>
  );
};

export default Alerts;
